import { render, staticRenderFns } from "./TopWord.vue?vue&type=template&id=23249d04&"
import script from "./TopWord.vue?vue&type=script&lang=js&"
export * from "./TopWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports